
import React from 'react';
import './App.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import AuthContainer from './components/auth/AuthContainer';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LabelPrinterApp from './components/LabelPrinterApp';
import SSOCallback from './components/auth/SSOCallback';

// Main App component with authentication
function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

// Component that decides whether to show auth or protected content
const AppContent = () => {
  const { user, loading } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="auth-container">
        <div className="auth-form">
          <div style={{ textAlign: 'center', padding: '40px 20px' }}>
            <div className="loading-spinner"></div>
            <p style={{ marginTop: '20px', color: '#666' }}>
              Loading...
            </p>
          </div>
        </div>
      </div>
    );
  }

  // If user is not authenticated, show authentication forms
  if (!user) {
    return <AuthContainer />;
  }

  // User is authenticated, show the protected label printer app
  return (
    <ProtectedRoute>
      <LabelPrinterApp />
    </ProtectedRoute>
  );
};

export default App;

